<style scoped>
@import '../../custom/css/cotacao-rejeitada.css';
</style>

<template>
  <div id="cotacao-perdida" class="cotacao-rejeitada">
    <div class="row m-0" v-if="!checkIsEmpty(cotacao)">
      <div class="col-12">
        <h1 class="title font-weight-bold text-uppercase">Orçamento Perdido</h1>
        <hr class="linha-amarela" />
      </div>
      <div class="col-12">
        <div class="card-cotacao">
          <div class="cc-header d-flex">
            <div class="cc-sub-title m-r-25">
              <img
                class="imagem-archive-cotacao"
                src="@/assets/img/icons/file-archive.png"
                alt="Ícone para representar o Orçamento"
              />
            </div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Data:
                <div
                  class="cc-sub-result"
                  v-if="cotacao.cotacao[0].criado_em !== null"
                >
                  {{ cotacao.cotacao[0].criado_em }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Cód:
                <div
                  class="cc-sub-result"
                  v-if="cotacao.cotacao[0].id !== null"
                >
                  {{ cotacao.cotacao[0].id }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Preferência:
                <div class="cc-sub-result" v-if="preferencia !== null">
                  {{ preferencia }}
                </div>
              </div>
            </div>
          </div>
          <div class="cc-content p-0">
            <div
              class="table-responsive"
              v-if="cotacao.cotacao[0].produtos.length > 0"
            >
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Marca</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Medida</th>
                    <th class="th">Foto</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in cotacao.cotacao[0].produtos"
                    :key="index"
                  >
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                      v-if="produto.produto"
                    >
                      {{ produto.produto.nome }}
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                      v-else
                    >
                      {{ produto.produto_nome }}
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      <div
                        class="d-inline-block"
                        v-if="produto.marca_nome !== null"
                      >
                        {{ produto.marca_nome }}
                      </div>
                      <div
                        class="d-inline-block"
                        v-else-if="produto.marca !== null"
                      >
                        {{ produto.marca.nome }}
                      </div>
                      <div class="d-inline-block" v-else>Sem Marca</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      <span class="ml-4">{{ produto.quantidade }}</span>
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      <div v-if="produto.medida !== null">
                        {{ produto.medida.nome }}
                      </div>
                      <div v-else-if="produto.medida_nome !== null">
                        {{ produto.medida_nome }}
                      </div>
                      <div v-else>Sem medida</div>
                    </td>
                    <td>
                      <div v-if="produto.foto !== null">
                        <img
                          class="img-small"
                          :src="`${getImagesAddress}` + produto.foto"
                          v-if="produto.foto !== null"
                        />
                      </div>
                      <div v-else>Sem foto</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-responsive" v-else>
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Preço Unitário</th>
                    <th class="th">Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in this.produtos"
                    :key="index"
                  >
                    <td width="50px">{{ index + 1 }}</td>
                    <td width="300px">
                      <input
                        type="text"
                        class="nome_produto"
                        width="300px"
                        v-model="produto.nome"
                      />
                    </td>
                    <td width="50px">
                      <input
                        type="number"
                        class="preco_unitario"
                        width="50px"
                        v-model="produto.quantidade"
                      />
                    </td>
                    <td width="140px">
                      <input
                        type="text"
                        class="preco_unitario"
                        v-model="produto.preco"
                        v-money="money"
                        maxlength="14"
                      />
                    </td>
                    <td width="140px">
                      <input
                        type="text"
                        class="preco_unitario"
                        v-money="money"
                        :value="subValor(produto.preco, produto.quantidade)"
                        readonly
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">
                      <div class="c-pointer" @click="adicionarProduto()">
                        <div class="btn-plus">
                          <i class="fas fa-plus"></i>
                        </div>
                        <div class="fs-14 d-inline-block p-left-10px">
                          Produto
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Campo de arquivo -->
            <div class="row m-0" v-if="cotacao.cotacao[0].arquivo !== null">
              <div class="col-12 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao.cotacao[0].quantidade_arquivo !== null"
                >
                  Quantidade: {{ cotacao.cotacao[0].quantidade_arquivo }}
                </div>
                <div
                  class="d-inline-block m-l-20px"
                  v-if="cotacao.cotacao[0].arquivo !== null"
                >
                  <a
                    :href="`${getImagesAddress}` + cotacao.cotacao[0].arquivo"
                    class="btn btn-primary c-pointer fs-14 text-uppercase bg-dark-blue"
                    download
                  >
                    Baixar arquivo
                    <i class="fas fa-file-upload m-l-7px"></i>
                  </a>
                </div>
              </div>
            </div>

            <!-- Campo de imagem -->
            <div class="row m-0" v-if="cotacao.cotacao[0].imagem !== null">
              <div class="col-12 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao.cotacao[0].quantidade_foto !== null"
                >
                  Quantidade: {{ cotacao.cotacao[0].quantidade_foto }}
                </div>
                <DownloadImages :allImages="this.cotacao.cotacao[0].imagem" />
              </div>
            </div>
          </div>
          <div class="cc-footer">
            <div class="position-relative p-10 text-right linha-abaixo-cinza">
              <div class="btn-voltar" @click="voltarCotacao()">Voltar</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DownloadImages from '../../components/DownloadImages';

export default {
  name: 'cotacao-perdida',
  components: {
    DownloadImages,
  },
  data: () => ({
    items: [],
    errors: [],
    produtos: [],
    motivo: {
      valor: null,
      mensagem: null,
      class: 'form-control',
    },
    frete: {
      valor: '',
      mensagem: null,
      class: 'form-control frete-input',
    },
    prazo: {
      valor: null,
      mensagem: null,
      class: 'datepicker',
    },
    valor_total: {
      valor: null,
      mensagem: null,
      class: 'form-control valor-total-input',
    },
    codicoes: {
      valor: null,
      mensagem: null,
      class: 'form-control codicoes-input',
    },
    orcamentodata: {
      valor: null,
      mensagem: null,
      class: 'datepicker',
    },
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: true,
    },
  }),
  props: ['cot_id', 'usu_id'],
  created() {
    let data = [];
    const self = this;

    data = {
      cot_id: this.cot_id,
      usu_id: this.usu_id,
    };

    if (this.checkIsEmpty(this.dadosUsuario)) {
      this.$router.push({ name: 'area-restrita' });
    }

    this.$store.dispatch('loadProdutoMarcas');

    this.$store.dispatch('emptyCotacao').then(() => {
      this.$store.dispatch('startLoader');
      setTimeout(() => {
        self.$store
          .dispatch('showCotacaoRejeitada', data)
          .then(() => {
            setTimeout(() => {
              self.$store.dispatch('endLoader');
            }, 1000);
          })
          .catch(() => {
            setTimeout(() => {
              self.$store
                .dispatch('showCotacaoRejeitada', data)
                .then(() => {
                  setTimeout(() => {
                    self.$store.dispatch('endLoader');
                  }, 1000);
                })
                .catch(() => {
                  self.$store.dispatch('endLoader');
                  self.aviso(
                    'Não foi possível carregar as cotações! Tente novamente em 5 minutos!',
                    'danger'
                  );
                });
            }, 1000);
          });
      }, 1000);
    });
  },
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      cotacao: (state) => state.cotacao,
      dadosUsuario: (state) => state.dadosUsuario,
      produtoMarcas: (state) => state.produtoMarcas,
    }),
    preferencia() {
      if (!this.checkIsEmpty(this.cotacao)) {
        const pref = this.cotacao.cotacao[0].preferencia;
        if (pref == 1) {
          return 'Menor Preço';
        }
        if (pref == 2) {
          return 'Custo-Benefício';
        }
        if (pref == 3) {
          return 'Melhor Marca';
        }
      } else {
        return 'Sem informação';
      }
    },
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    voltarCotacao() {
      this.$router.push({
        name: 'lojista-perdidas',
      });
    },
    retirarAvisos() {
      this.errors = [];
      this.motivo.class = 'form-control';
      this.frete.class = 'form-control frete-input';
      this.prazo.class = 'datepicker';
      this.valor_total.class = 'form-control valor-total-input';
      this.codicoes.class = 'form-control codicoes-input';
      this.orcamentodata.class = 'datepicker';
    },
    unsMaskValor(valor) {
      return parseInt(String(valor).replace(/[\D]+/g, ''));
    },
    subValor(valor, quantidade) {
      let valorString = String(valor);
      if (quantidade === null) {
        valorString = parseInt(valorString.replace(/[\D]+/g, '')) * parseInt(0);
      } else {
        valorString =
          parseInt(valorString.replace(/[\D]+/g, '')) * parseInt(quantidade);
      }
      return valorString;
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    adicionarProduto() {
      this.produtos.push({
        nome: null,
        quantidade: null,
        preco: null,
      });
    },
  },
};
</script>
